import useSWR from 'swr';
import { customSWRConfig, customSWRResponse } from '../../model/types';
import useSWRCacheKeys from '../useSWRCacheKeys';

enum AssgineePlaceholdersOnCommentAction {
    'ticket.assignee.email' = 'ticket.assignee.email',
    'ticket.assignee.full_name' = 'ticket.assignee.full_name',
    'ticket.assignee.phone' = 'ticket.assignee.phone',
    'ticket.assignee.group.name' = 'ticket.assignee.group.name'
}

enum RequesterPlaceholdersOnCommentAction {
    'ticket.requester.email' = 'ticket.requester.email',
    'ticket.requester.full_name' = 'ticket.requester.full_name',
    'ticket.requester.phone' = 'ticket.requester.phone'
}

enum PlaceholdersOnCommentAction {
    'current_user.email' = 'current_user.email',
    'current_user.full_name' = 'current_user.full_name',
    'current_user.phone' = 'current_user.phone',
    'ticket.assignee.email' = 'ticket.assignee.email',
    'ticket.assignee.full_name' = 'ticket.assignee.full_name',
    'ticket.assignee.phone' = 'ticket.assignee.phone',
    'ticket.key' = 'ticket.key',
    'ticket.requester.email' = 'ticket.requester.email',
    'ticket.requester.full_name' = 'ticket.requester.full_name',
    'ticket.requester.phone' = 'ticket.requester.phone',
    'ticket.subject' = 'ticket.subject'
}

const PlaceholdersOnCommentActionLabelMap = {
    'current_user.email': 'Your primary email',
    'current_user.full_name': 'Your full name',
    'current_user.phone': 'Your primary phone number',
    'ticket.assignee.email': `Assignee's primary email`,
    'ticket.assignee.full_name': `Assignee's full name`,
    'ticket.assignee.phone': `Assignee's primary phone number`,
    'ticket.key': `Ticket's key`,
    'ticket.requester.email': `Requester's primary email`,
    'ticket.requester.full_name': `Requester's full name`,
    'ticket.requester.phone': `Requester's primary phone number`,
    'ticket.subject': `Ticket's subject`
};

type placeholderOnCommentActionType = keyof typeof PlaceholdersOnCommentAction;

export default function usePlaceholderListOnCommentAction(
    config: customSWRConfig = {}
): customSWRResponse<{ placeholder: placeholderOnCommentActionType; description: string }[]> {
    const keys = useSWRCacheKeys('/macros/available-placeholders?actionType=COMMENT');

    const { data, error, isLoading } = useSWR<placeholderOnCommentActionType[]>(keys, { ...config });

    return {
        data: data?.map((placeholder) => ({
            placeholder,
            description: PlaceholdersOnCommentActionLabelMap[placeholder]
        })),
        error,
        isLoading
    };
}

export { AssgineePlaceholdersOnCommentAction, PlaceholdersOnCommentAction, RequesterPlaceholdersOnCommentAction };
export { type placeholderOnCommentActionType };
